import { useSelector } from 'react-redux';

import { selectMyProfile } from '@app/modules/my-profile';
import { useAuthRole } from './use-auth-role';

const useAuthRolePermissions = () => {
  const authRolePermissions = useSelector(selectMyProfile);
  const { isSuperAdmin } = useAuthRole();
  const hasPermission = (module: string, action: any) => {
    if (isSuperAdmin) {
      return true;
    }
    return authRolePermissions?.role?.permissions?.[module]?.includes(action);
  };
  return { hasPermission };
};
export { useAuthRolePermissions };
